// Generated by CoffeeScript 1.6.3
/**
 * Common module for all window scroll functions
*/

itsoftApp.createModule("windowScroll", function() {
  var $window, events, module;
  module = this;
  events = [];
  $window = itsoftApp.commonVars.$window;
  $window.on("scroll", function() {
    var f, y, _i, _len, _results;
    y = document.body.scrollTop || document.documentElement.scrollTop;
    _results = [];
    for (_i = 0, _len = events.length; _i < _len; _i++) {
      f = events[_i];
      _results.push(f.call(this, y));
    }
    return _results;
  });
  return module.addEvent = function(func) {
    if (typeof func !== "function") {
      return;
    }
    events.push(func);
    return DEBUG && console.log("[module windowScroll] function added, count of functions to init now: " + events.length);
  };
});

/*
//@ sourceMappingURL=windowScroll.map
*/
